interface ViewProps {
    selectedDate: Date;
    appointments: any[];
    clientsById: Map<string, any>;
    barbersById: Map<string, any>;
    onDayClick?: (date: Date) => void;
    onAppointmentClick?: (appointment: any) => void;
    getBarberColors?: (barberId: string, status: string) => string;
}

export default function WeekView({
    selectedDate,
    appointments,
    clientsById,
    onAppointmentClick,
    getBarberColors,
}: ViewProps) {
    const getWeekDays = (date: Date) => {
        const days = [] as Array<Date>;
        const startOfWeek = new Date(date);
        startOfWeek.setDate(date.getDate() - date.getDay());

        for (let i = 0; i < 7; i++) {
            const day = new Date(startOfWeek);
            day.setDate(startOfWeek.getDate() + i);
            days.push(day);
        }
        return days;
    };

    const weekDays = getWeekDays(selectedDate);
    const hours = Array.from({ length: 14 }, (_, i) => i + 8);
    const today = new Date();

    const getApptsForDayAndHour = (date: Date, hour: number) => {
        const dayStart = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            hour,
        ).getTime();
        const dayEnd = dayStart + 60 * 60 * 1000;
        return appointments.filter(
            (a) => a.startTime >= dayStart && a.startTime < dayEnd,
        );
    };

    return (
        <div>
            <div className="px-3 py-2 border-b border-gray-200 dark:border-gray-700">
                <div className="grid grid-cols-8 gap-1">
                    <div className="p-1"></div>
                    {weekDays.map((day, index) => (
                        <div key={index} className="p-1 text-center">
                            <div
                                className={`text-xs font-bold ${
                                    day.toDateString() === today.toDateString()
                                        ? "text-emerald-600 dark:text-emerald-400"
                                        : "text-gray-900 dark:text-white"
                                }`}
                            >
                                {`${day.toLocaleDateString("pt-BR", {
                                    weekday: "short",
                                })} ${day.getDate()}`}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="max-h-[600px] overflow-y-auto">
                {hours.map((hour) => (
                    <div
                        key={hour}
                        className="grid grid-cols-8 gap-1 border-b border-gray-100 dark:border-gray-700"
                    >
                        <div className="p-2 text-sm text-gray-500 dark:text-gray-400 text-right">
                            {hour}:00
                        </div>
                        {weekDays.map((day, dayIndex) => {
                            const hourAppts = getApptsForDayAndHour(day, hour);
                            return (
                                <div
                                    key={dayIndex}
                                    className="p-1 min-h-[60px] border-r border-gray-100 dark:border-gray-700"
                                >
                                    {hourAppts.map((appt, i) => {
                                        const client = clientsById.get(
                                            String(appt.clientId),
                                        );
                                        const colorClass = getBarberColors
                                            ? getBarberColors(
                                                  String(appt.barberId),
                                                  appt.status,
                                              )
                                            : "bg-emerald-100 dark:bg-emerald-900 text-emerald-800 dark:text-emerald-200 border-emerald-200 dark:border-emerald-700";
                                        return (
                                            <div
                                                key={i}
                                                className={`text-xs p-2 rounded-xl border mb-1 transition-all duration-300 relative backdrop-blur-sm cursor-pointer ${colorClass}`}
                                                onClick={() =>
                                                    onAppointmentClick?.(appt)
                                                }
                                            >
                                                <div className="font-medium truncate">
                                                    {client?.name || "Cliente"}
                                                </div>
                                                <div className="truncate opacity-90">
                                                    {appt.service}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}
